import React, { useState, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';
import logo from '../imagenes/opensiii.png'
export function Toasts(props) {

  const btnClose = useRef();
  let op = require('../../src/modulos/datos');


  return (
    <div
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.479)', position: 'fixed',top:0,left:0,right: 0,
      bottom: 0,justifyContent: 'center', alignItems: 'center',visibility: props.show ? 'visible' : 'collapse', 'zIndex': 99 }}
      className='d-flex justify-content-center mx-auto p-0 mx-0'


    >
      <Col md={12} className="mb-2 d-flex justify-content-center align-self-center mx-0"   >

        <Toast
          {...props}

          onShow={() => {
            console.log('hola')
          }}
          className='bg-light border-toast' 
          /* delay={2500}  */
          autohide
          onClose={() => props.onHideCancela()}
          onClick={() => props.onHideCancela()}>
          {/*  <Toast.Header >
           
          </Toast.Header> */}
          <Toast.Body className=' row mx-auto' >


            <div className='col align-self-center '>
              <img src={logo} style={{ height: '45px' }} alt="footer" />
            </div>
            <div className='col-md-8 align-self-center row justify-content-center'>
              <label className='fw-bold text-center text-dark' >{props.mensaje} </label>

            </div>

          </Toast.Body>

        </Toast>
      </Col>

    </div>
  );
}

export function ToastsFecha(props) {

  const btnClose = useRef();


  return (
    <Row
      {...props}
      className='d-flex justify-content-center'


      onShow={() => {
        console.log('hola')
      }}
    >
      <Col md={12} className="mb-2 d-flex justify-content-center align-self-center" style={{ background: '#0808085e', height: '52vw', marginTop: '-20%', visibility: props.show ? 'visible' : 'collapse' }}>

        <Toast show={props.show} className='bg-light border-toast' position='top-end' style={{ position: 'absolute', marginTop: '30%' }}    /* delay={2500} autohide   */
          onClose={() => props.onHideCancela()} >
          {/*  <Toast.Header >
           
          </Toast.Header> */}
          <Toast.Body className=' row' >


            <div className='col-md-2 align-self-center border-dark border-end py-3 '>
              <label className='icon-toast mt-2'>S</label>
            </div>
            <label className='fw-bold text-center text-dark mt-3 px-0 col-md-7 ml-4' >{props.mensaje} </label>
            <div className='col align-self-center justify-content-center'>
              <a href="#" ref={btnClose} className='text-danger ml-3 fa-lg' onClick={() => props.onHideCancela()}><i className="far fa-times-circle"></i></a>
            </div>

          </Toast.Body>

        </Toast>
      </Col>

    </Row>
  );
}

export function ToastsGeneral(props) {

  const btnClose = useRef();


  return (
    <Row
      {...props}
      className='d-flex justify-content-center mx-auto p-0'
      onShow={() => {
        console.log('hola')
      }}
    >
      <Col md={12} className="mb-2 d-flex justify-content-center align-self-center mx-auto" style={{ background: '#0808085e', height: '55vw', width: '80vw', marginTop: '-38%', visibility: props.show ? 'visible' : 'collapse' }}>

        <Toast show={props.show} className='bg-light border-toast' position='top-end' style={{ position: 'absolute', marginTop: '30%' }} delay={2500} autohide
          onClose={() => props.onHideCancela()} >
          {/*  <Toast.Header >
           
          </Toast.Header> */}
          <Toast.Body className=' row' >


            <div className='col-md-2 align-self-center border-dark border-end py-3 '>
              <label className='icon-toast mt-2'>S</label>
            </div>
            <label className='fw-bold text-center text-dark mt-3 px-0 col-md-7 ml-4' >{props.mensaje} </label>
            <div className='col align-self-center justify-content-center'>
              <a href="#" ref={btnClose} className='text-danger ml-3 fa-lg' onClick={() => props.onHideCancela()}><i className="far fa-times-circle"></i></a>
            </div>

          </Toast.Body>

        </Toast>
      </Col>

    </Row>
  );
}